<template>
  <q-dialog
    :value="open"
    position="left"
    full-height
    @hide="$emit('close')"
    @touchend.stop
    @touchstart.stop
  >
    <div class="side-panel-menu">

      <div class="shop-logo">
        <img
          v-if="styleObj && styleObj.logo && !shopLogoError"
          alt="logo"
          :src="isElectron() ? apiUrl + styleObj.logo : styleObj.logo"
          @click="$router.push('/')"
          @error="shopLogoError = true"
        >
      </div>
      <div class="text-right text-color2 shop-name">
        {{$t('mainLayout.shopTitle')}}:
        <div v-if="shop">{{shop.name}}</div>
      </div>
      <div class="current-time">
        {{ currentTime }}
      </div>

      <div class="other-spacer" />

      <div
        class="side__other-controls q-mx-md"
      >
        <q-btn
          @click="changeLang"
          class="locale-option"
        >
          <span
            :class="{active: activeLocale === 'ru-ru'}"
          >
            {{ $t('mainTerms.rus') }}
          </span>
          /
          <span
            :class="{active: activeLocale === 'en-us'}"
          >
            {{ $t('mainTerms.eng') }}
          </span>
        </q-btn>
        <q-btn
          v-if="apiUrl"
          round
          color="#fff"
          text-color="grey-9"
          icon="logout"
          @click="clearApiUrl"
        />
      </div>

    </div>
  </q-dialog>
</template>

<script>
import { isElectron } from '../common/helpers'

export default {
  name: 'MobileSideMenu',

  props: {
    open: {
      type: Boolean,
      default: false
    },
    activeLocale: {
      type: String,
      default: ''
    },
    shop: {
      type: Object,
      default: () => ({})
    },
    styleObj: {
      type: Object,
      default: () => ({})
    },
    locales: {
      type: Array,
      default: () => ['ru-ru', 'en-us']
    },
    apiUrl: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      shopLogoError: false,
      currentTimeStamp: new Date(),
      timer: null,
      isElectron
    }
  },

  computed: {
    currentTime () {
      return this.currentTimeStamp.toLocaleString(this.activeLocale, { hour: '2-digit', minute: '2-digit' })
    }
  },

  mounted () {
    this.timer = setInterval(() => {
      this.currentTimeStamp = new Date()
    }, 1000)
  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  methods: {
    changeLang () {
      const newLang = this.locales.filter(el => el !== this.activeLocale)
      if (newLang[0]) {
        this.$emit('changeLocale', newLang[0])
      }
    },

    clearApiUrl () {
      localStorage.removeItem('apiUrl')
    }
  }
}
</script>

<style lang="stylus" scoped>

.side-panel-menu
  background-color: $bg-color
  width: 75vw
  display: flex
  flex-direction: column
  align-items: flex-start

  img
    object-fit: cover
    width: 100%
    // background-color: black

.shop-logo
  width: 100%
  min-height: 50px
  padding: 8px 10px

.shop-name,
// .shop-name > *
  width: 100%
  margin: 0 0 20px 0
  padding: 10px 4px 0 4px

  color: $text-color
  font-size: 24px
  text-align: center
  text-overflow: ellipsis
  white-space: nowrap
  overflow: hidden

.shop-name > *
  white-space: pre-wrap

.side
  &__other-controls
    display: flex
    align-items: center
    align-self: center
    flex-direction: column
    padding-bottom: 20px
    gap: 10px

    &_btn
      background: $bg-color
      color: $text-color

.current-time
  font-size: 30px
  text-align: center
  color: $text-color
  width: 100%

.locale-option
  min-width: 60px
  padding: 5px
  color: $text-color
  font-weight: normal

  & .active
    color: var(--q-color-primary)
    font-weight: bold

.exit-spacer
  padding: 40px 0

.other-spacer
  margin-top: auto

.q-dialog__inner--fullheight
  padding: 0 !important

</style>
